<template>
  <div v-if="subPath != 'dashboard'">
    <AlarmHeader @back="goBack" :title="headerTitle"/>
    <AddBtn v-if="showAddBtn()" @click="openModal(subPath)"/>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { useI18n } from "vue-i18n";
import { ref, watch, computed, onMounted  } from 'vue'
import { useRoute, useRouter } from "vue-router";

import { chkPermission } from '@/utils/permission.js'

import AddBtn from "@/components/button/AddBtn.vue";
import AlarmHeader from "@/components/alarm/common/AlarmHeader.vue";

const { t } = useI18n();

const store = useStore();
const route = useRoute();
const router = useRouter();
const userPackage = ref(localStorage.getItem("userPackage"));
const result = ref(null);
const checkingPermission = ref(true);
const alarmPayment =ref();
const alarmModal = computed(() => store.state.alarmReg.clickAlarm)

async function getUserPackage() {
  checkingPermission.value = true;

  try {
    result.value = await chkPermission();
    userPackage.value = Number(result.value.userPackage) || 0;
    alarmPayment.value = result.value.alarmPayment
  } finally {
    checkingPermission.value = false;
  }
}

onMounted(async () => {
  await getUserPackage();
});


// 경로 관련
const subPath = ref(route.path?.split('/')[2])
const type = ref(route.query.type)

// 탭별 제목 매치
const headerList = ref({
  'price': t('alarm.menu.price'),
  'score': t('alarm.menu.score'),
  'support-resistance': t('alarm.menu.sr'),
  'premium': t('alarm.menu.premiumSignal'),
  'smart': t('alarm.menu.smart'),
  'next': t('alarm.menu.next'),
  'goya': t('alarm.menu.next'),
  'light': t('alarm.menu.light'),
  'light-detail': t('alarm.menu.light'),
  'real': t('alarm.menu.real'),
  'rocket': t('rocket.alert'),
});

// 선택된 탭
const headerTitle = ref(headerList.value[subPath.value]);

watch(() =>  route.path, async(newVal) => {
  await getUserPackage()
  subPath.value =  newVal.split('/')[2]
  type.value = route.query.type
  headerTitle.value = headerList.value[subPath.value];
})

// 뒤로가기
function goBack() {
  if (subPath.value == 'light-detail') {
    router.back();
    return;
  }

  router.push('/alarm/dashboard')
}

// 각 페이지에 맞는 메뉴얼 열기 기능
function openModal(subPath) {
  if (subPath == 'price') {
    // store.commit('alarmReg/changeAlarm', { state: true });
    router.push('/alarm/insight-coin')
  } 
  else {
    router.push(`/alarm/plus-coin?sub=${subPath}&type=${type.value}`)
  }
}

// 코인 추가 버튼 조건
function showAddBtn() {
  const path = subPath.value;
  const packagePrice = Number(userPackage.value) || 0;

  const hiddenPaths = [
    'dashboard',
    'next',
    'score',
    'plus-coin',
    'insight-coin',
    'rocket',
    'light',
    'light-detail',
    'change-coin'
  ];

  // 모달 열려있으면 안 보임
  if (alarmModal.value) {
    return false;
  }

  // 제외 경로면 안 보임
  if (hiddenPaths.includes(path)) {
    return false;
  }

  // price 페이지는 패키지 1000 이상일 때만 보임
  if (path === 'price') {
    let priceOk;

    if (Number(packagePrice) < 1000) {
      priceOk = false;
    }

    else if (Number(packagePrice) <= 3000 && !alarmPayment.value) {
      priceOk = false;
    }

    else if (Number(packagePrice) <= 3000 && alarmPayment.value) {
      priceOk = true;
    }

    else if (Number(packagePrice) >= 5000) {
      priceOk = true;
    }

    return priceOk;
  }

  // 기존 조건 그대로면 price 말고는 안 보임
  return true;
}
</script>

<style scoped>

</style>
